import { HttpStatusCode } from "axios";
import { getApiErrorStatus } from "_shared/_errors/api-error-message";

/**
 * What to tell a user whose message got no answer at all.
 *
 * A failure the assistant itself reports arrives as an answer, at 200, and is shown as one. This is
 * for the request that never produced an answer. Before this, the panel only wrote it to the
 * console, so a refused turn looked like a message the assistant ignored.
 *
 * 429 is a turn limit: the user's own rate, or the brake the cost alarms engage, which cuts every
 * user's rate. Waiting fixes both. 503 is the brake paused by a person: no turn starts until they
 * release it, so the message does not suggest trying again in a moment.
 */
export function describeTurnFailure(error: unknown): string {
  const status = getApiErrorStatus(error);

  if (status === HttpStatusCode.TooManyRequests) {
    return "The assistant is taking fewer messages right now. Wait a minute, then send it again.";
  }

  if (status === HttpStatusCode.ServiceUnavailable) {
    return "The assistant is paused. Your message was not sent. Please try again later.";
  }

  return "The assistant could not answer that. Please try again.";
}
